class ProductRegisterArticle extends HTMLElement {
  constructor() {
    super();
    this.validFileTypes = [
      "image/png",
      "image/jpeg",
      "image/gif",
      "image/webp",
      "image/bmp",
      "application/pdf",
    ];
    this.validFileSize = 6;
  }

  // Called when the element is added to the DOM
  connectedCallback() {
    this.form = this.querySelector("#product-register-form");

    this.submitBtn = this.querySelector(`button[type='submit']`);

    this.fileInput = this.querySelector("#preg_proof_of_purchase");

    this.receiptCheckbox = this.querySelector("#preg_dont_have_receipt");

    this.form.addEventListener("submit", this.formSubmissionHandler.bind(this));

    this.successMessage = this.querySelector("#product-register-form--success");

    this.errorMessage = this.querySelector("#product-register-form--error ");

    this.fileInput.addEventListener(
      "change",
      this.fileInputEventHandler.bind(this)
    );
  }

  // Called when the element is removed from the DOM
  disconnectedCallback() {
    this.fileInput.removeEventListener(
      "change",
      this.fileInputEventHandler.bind(this)
    );
  }

  /**
   * Event handler for file input changes
   * @param {Event} event File input event
   *
   * Check if the file is valid in both type and size
   */
  fileInputEventHandler(event) {
    const fileInput = event.target;
    const files = fileInput.files;
    const isValidType = this.fileTypeValidation(files);
    const isValidSize = this.fileSizeValidation(files);

    if (!isValidType || !isValidSize) {
      if (!isValidSize) {
        alert("Please upload proof of purchase in correct file size: 6MB");
      } else if (!isValidType) {
        alert(
          "Please upload proof of purchase in correct file type: PNG, JPG, JPEG, PDF"
        );
      } else {
        alert("Please upload proof of purchase in correct file type and size");
      }

      this.submitBtn.disabled = true;
      return;
    }

    this.submitBtn.disabled = false;
  }

  async formSubmissionHandler(event) {
    event.preventDefault();

    this.setLoadingState(true);

    const receiptOptionsAreEmpty =
      this.fileInput.value === "" && this.receiptCheckbox.checked === false;

    if (receiptOptionsAreEmpty) return;
    const formData = new FormData(this.form);

    try {
      const response = await fetch(
        "https://20kb1qwkj2.execute-api.us-west-2.amazonaws.com/prod/register",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.status === 200) {
        this.successMessage.style.display = "block";
      }

      if (response.status === 500) {
        this.errorMessage.style.display = "block";
      }
    } catch (error) {
      console.error(`Page Product Register | formSubmissionHandler | ${error}`);
    } finally {
      this.form.style.display = "none";
      this.setLoadingState(false);
    }
  }

  /**
   * Method to validate the file type
   * @param {Array} files Input files
   * @returns {Boolean} Check if the file type is in the list of valid types
   */
  fileTypeValidation(files) {
    const fileType = files[0].type;
    return this.validFileTypes.includes(fileType);
  }

  /**
   * Method to validate the file size
   * @param {Array} files Input files
   * @returns {Boolean} Check if the size is within the valid limit
   */
  fileSizeValidation(files) {
    const fileSize = files[0].size;
    const size = (fileSize / 1024 / 1024).toFixed(2);
    return size <= this.validFileSize;
  }

  setLoadingState(flag) {
    this.submitBtn.disabled = flag;
    this.submitBtn.innerHTML = flag ? "SUBMITTING..." : "REGISTER";
  }
}

customElements.define("product-register-article", ProductRegisterArticle);
